var paragraph_default = {
  "fontElementMap": "QiJAI",
  "elementSpacing": "ZPZWP",
  "text": "lcDvi ZPZWP",
  "child": "D7n8k"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
